module.exports = __webpack_public_path__ + "img/avatar.8c68a76d.png";